import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const isAuthenticated = token !== null;

  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Primary Sidebar
  const [isSecondaryOpen, setIsSecondaryOpen] = useState(false); // Secondary Sidebar

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleSecondarySidebar = (isOpen) => {
    setIsSecondaryOpen(isOpen);
  };

  if (!isAuthenticated) {
    return <Navigate to="/signin" />;
  }

  return (
    <div className="protected-layout">
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar 
        isOpen={isSidebarOpen} 
        toggleSidebar={toggleSidebar} 
        toggleSecondarySidebar={toggleSecondarySidebar} 
      />
      <div className={`main-content`}>
        {children}
      </div>
    </div>
  );
};

export default ProtectedRoute;
